export type AdPlacementId = "sideRailLeft" | "sideRailRight" | "mobileStickyBottom";

export interface AdPlacementMeta {
  labelEn: string;
  labelFi: string;
  format: "sidebar" | "mobile";
}

export const AD_PLACEMENTS: Record<AdPlacementId, AdPlacementMeta> = {
  sideRailLeft: {
    labelEn: "Left sidebar",
    labelFi: "Vasen sivupalkki",
    format: "sidebar",
  },
  sideRailRight: {
    labelEn: "Right sidebar",
    labelFi: "Oikea sivupalkki",
    format: "sidebar",
  },
  mobileStickyBottom: {
    labelEn: "Mobile · sticky bottom",
    labelFi: "Mobiili · kiinteä alareuna",
    format: "mobile",
  },
};

export const getPlacementSlotId = (placementId: AdPlacementId): string | undefined => {
  const envMap: Record<AdPlacementId, string | undefined> = {
    sideRailLeft: import.meta.env.VITE_ADSENSE_SLOT_SIDE_LEFT,
    sideRailRight: import.meta.env.VITE_ADSENSE_SLOT_SIDE_RIGHT,
    mobileStickyBottom: import.meta.env.VITE_ADSENSE_SLOT_MOBILE_BOTTOM,
  };

  const slot = envMap[placementId]?.trim();
  return slot || undefined;
};
